import { List, ListItem } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { HEADER_LINK_STYLE, HEADER_LI_STYLE } from '../../../constants/layout';
import { ReactLink } from '../../../models/common';
import { LinkOrMenu } from '../../../utils/layout';
import { Button } from '../../atoms/Button';

export type HeaderLinksDesktopProps = {
  links: LinkOrMenu[];
  dropdownVisible: boolean;
  setDropdown: (sublinks: ReactLink[], index?: number) => void;
};

export const HeaderLinksDesktop = ({ links, setDropdown }: HeaderLinksDesktopProps) => {
  const location = useLocation();
  const activeDropdownIndex = links.findIndex((link) =>
    link.subLinks?.some((subLink) => location.pathname === subLink.to)
  );
  return (
    <List
      sx={{
        display: 'flex',
        columnGap: '2rem',
        justifyContent: 'space-between',
        alignItems: 'stretch'
      }}
    >
      {links.map(({ label, to, href, subLinks }, index) => {
        const isCurrentPage: boolean = Boolean(to && location.pathname === to) || activeDropdownIndex === index;
        return (
          <ListItem
            key={label}
            sx={{ ...HEADER_LI_STYLE({ isActive: isCurrentPage }), p: '8px' }}
            {...(isCurrentPage ? { 'aria-current': true } : {})}
          >
            <Button
              to={to}
              href={href}
              disableRipple
              onClick={() => {
                // If item has sublinks, trigger setDropdown action
                if (subLinks && subLinks.length !== 0) {
                  setDropdown(subLinks, index);
                }
                // Else, empty dropdown
                else {
                  setDropdown([]);
                }
              }}
              sx={{ ...HEADER_LINK_STYLE({ isActive: isCurrentPage }), maxWidth: '9rem' }}
              {...(isCurrentPage ? { 'aria-current': 'page' } : {})}
            >
              {label}
            </Button>
          </ListItem>
        );
      })}
    </List>
  );
};
